import { observer } from "mobx-react";
import React from "react";
import { Modal } from "@mantine/core";

import { BOB_MODALS } from "../../helpers/constants";

import { Bob } from "../../stores/Bob";

import ShowBobNostrConnection from "./showBobNostrConnection";
import EditBobNostrConnection from "./editBobNostrConnection";

const SingleBobNostrConnection = observer(({ bob }: { bob: Bob }) => {
  const selectedBobNostrConnection = bob.selectedNostrConnection;
  const closeModal = () => {
    selectedBobNostrConnection.setEditorialViewStatus(null);
    bob.setOpenModal(null);
  };

  return (
    <>
      {selectedBobNostrConnection && (
        <Modal
          opened={bob.openModal === BOB_MODALS.SINGLE_NOSTR_CONNECTION}
          onClose={() => bob.setOpenModal(null)}
          title={`${
            selectedBobNostrConnection.editorialViewStatus === "edit"
              ? "Edit NWC Connection"
              : "Get NWC Connection Details"
          } `}
        >
          <>
            {selectedBobNostrConnection.editorialViewStatus === "edit" && (
              <EditBobNostrConnection bob={bob} />
            )}
            {selectedBobNostrConnection.editorialViewStatus === "show" && (
              <ShowBobNostrConnection bob={bob} />
            )}
          </>
        </Modal>
      )}
    </>
  );
});

export default SingleBobNostrConnection;
